<template>
	<div>
		<div class="app-header" :class="{ 'at-top': isInTop }">
			<a href="/" class="app-header-logo">
				<img src="../images/svg/normal.svg" alt />
			</a>
			<div class="app-header-menu">
				<div class="nav-icon" @click="troggleMenu"></div>
				<ul
					class="menu-list"
					:class="{ active: visiable }"
					@click="jumpToTarget"
				>
					<li class="is-mobile menu-item user-name" v-if="userName">
						<a
							href="javascript:;"
							v-html="
								`${getConstants('ACCOUNT')}${getConstants('COLON')} ${userName}`
							"
						></a>
					</li>
					<li class="menu-item">
						<a href="javascript:;" ref="home">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_HOME')
						}}</a>
					</li>
					<li class="menu-item not-mobile">
						<a href="#app_benifits">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_MORE')
						}}</a>
					</li>

					<li class="menu-item">
						<a href="#app_sale">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_PRICING')
						}}</a>
					</li>
					<li class="menu-item not-mobile">
						<a href="#app_more">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_FEATURES')
						}}</a>
					</li>
					<li class="menu-item">
						<a href="#app_faq">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_FAQ')
						}}</a>
					</li>
					<li class="menu-item" v-if="!userName && !isWechat">
						<a :href="loginHref">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_SIGNIN')
						}}</a>
					</li>
					<li class="menu-item" v-if="!userName && !isWechat">
						<a :href="signUpHref">{{
							getConstants('EAGLE_LANDING_HEADER_MENU_SIGNUP')
						}}</a>
					</li>
					<li class="not-mobile menu-item buy">
						<a @click="freeTrialClick" href="javascript:;">{{
							getConstants('EAGLE_LANDING_COMMON_FREE')
						}}</a>
					</li>
					<li class="is-mobile menu-item">
						<a @click="freeTrialClick" href="javascript:;">{{
							getConstants('EAGLE_LANDING_COMMON_FREE')
						}}</a>
					</li>
					<li
						class="not-mobile menu-item user-name"
						@click="logoutVisiable = !logoutVisiable"
						:class="{ active: logoutVisiable }"
						ref="logout"
						v-if="userName"
					>
						<a class="css-ellipsis" href="javascript:;" v-html="userName"></a>
						<p class="logout">
							<a href="javascript:;" @click="logout">{{
								getConstants('LOGOUT')
							}}</a>
						</p>
					</li>
					<li class="is-mobile menu-item red" v-if="userName">
						<a href="javascript:;" @click="logout">{{
							getConstants('LOGOUT')
						}}</a>
					</li>
				</ul>
			</div>
		</div>
		<div
			class="menu-bg is-mobile"
			:class="{ active: visiable }"
			@click="visiable = false"
		></div>
	</div>
</template>
<script>
import { Client } from '../../../utils/client'
import buyStore from '../buyStore'

export default {
	props: {
		isInTop: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			visiable: false,
			userName: PageInfo.user_name,
			logoutVisiable: false,
			isWechat: Client.isWechat,
		}
	},
	computed: {
		loginHref() {
			return `/d/login?next=${encodeURIComponent(location.href)}`
		},
		signUpHref() {
			return `/d/signup?next=${encodeURIComponent(location.href)}`
		},
	},
	methods: {
		troggleMenu() {
			this.visiable = !this.visiable
		},
		jumpToTarget(e) {
			if (e.target.tagName === 'A') {
				this.$emit('jumpToTarget', e.target === this.$refs.home)
				this.visiable = false
			}
		},
		logout() {
			location.href = `/logout?next=${encodeURIComponent(location.href)}`
		},
		freeTrialClick() {
			if (!this.PageInfo.accountState) {
				location.href = `/d/signup?next=/s/tutorial/eagle?coupon_code=${buyStore.coupon.coupon_code}`
			} else {
				location.href = `/s/tutorial/eagle?coupon_code=${buyStore.coupon.coupon_code}`
			}
		},
	},
	mounted() {
		buyStore.$on('bodyClicked', e => {
			if (
				this.$refs.logout &&
				e.target !== this.$refs.logout &&
				!this.$refs.logout.contains(e.target)
			) {
				this.logoutVisiable = false
			}
		})
	},
}
</script>

<style lang="scss" scoped>
$menuColor: #829cca;
$zindex: 99;
.app-header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 70px;
	z-index: $zindex;
	display: flex;
	align-items: center;
	background: #fff;
	justify-content: space-between;
	border-bottom: 1px solid #e6e6e6;
	.app-header-logo {
		height: 100%;
		width: 120px;
		margin-left: 40px;
		img {
			width: 120px;
			height: 34px;
			padding-top: 18px;
		}
	}

	.app-header-menu {
		height: 100%;
	}

	.app-header-menu button {
		display: none;
	}
	.menu-item.buy {
		a {
			margin-top: 17px;
			display: inline-block;
			height: 36px;
			padding: 0 16px;
			border-radius: 18px;
			text-align: center;
			line-height: 36px;
			background-color: #107ffc;
			color: #fff;
		}
	}
	.menu-item.red {
		a {
			color: #ff2a43;
		}
	}
	.menu-list {
		display: flex;
		height: 100%;
		padding-right: 40px;
	}

	.menu-item {
		margin-left: 40px;
	}

	.menu-item a {
		line-height: 70px;
		color: $menuColor;
	}
	.user-name.not-mobile {
		position: relative;
		align-items: center;
		flex-direction: row-reverse;
		padding-right: 20px;
		> a {
			display: block;
			max-width: 160px;
		}
		&::before {
			content: '';
			right: 0;
			top: 26px;
			position: absolute;
			width: 16px;
			height: 16px;
			background: url('../images/svg/tail-down.svg') 0 0/16px 16px no-repeat;
			transition: transform ease 0.5s;
			cursor: pointer;
		}
		.logout {
			position: absolute;
			display: none;
			right: 0;
			top: 54px;
			width: 120px;
			height: 40px;
			line-height: 32px;
			text-indent: 16px;
			background: #fff;
			a {
				display: block;
				margin-top: 4px;
				line-height: 32px;
				&:hover {
					background-color: #f9f9f9;
				}
			}
		}
	}
	.user-name.active {
		&::before {
			transform: rotate(180deg);
		}
		.logout {
			display: block;
		}
	}
}

@media screen and (min-width: 1200px) {
	.at-top {
		background: transparent;
		border-bottom: none;
	}
}

@media screen and (max-width: 1200px) and (min-width: 767px) {
	.at-top {
		background: transparent;
		border-bottom: none;
	}
	.app-header {
		.menu-item {
			margin-left: 20px;
		}
		.menu-list {
			padding-right: 10px;
		}
	}
}

@media (max-width: 767px) {
	.app-header {
		background: #fff;
		.is-mobile {
			display: block;
		}
		.not-mobile {
			display: none;
		}
		.app-header-logo {
			margin-left: 16px;
		}
	}
	.app-header-menu {
		.menu-list {
			position: absolute;
			display: block;
			height: auto;
			padding-right: 0;
			z-index: $zindex + 1;
			top: 70px;
			right: 0;
			width: 100%;
			border-top: 1px solid #e6e6e6;
			background-color: #ffffff;
			max-height: 0;
			overflow: hidden;
			transition: max-height ease 0.5s;
		}
		.menu-list.active {
			max-height: 500px;
		}

		.menu-item {
			margin-left: 40px;
			margin-right: 40px;
			a {
				margin: 8px 0;
				display: block;
				line-height: 24px;
				font-size: 16px;
				text-align: left;
				color: #829cca;
			}
			&:hover {
				background: #eee;
			}
		}
		.user-name {
			&::before {
				display: none;
			}
			a {
				margin: 20px 0;
				line-height: 20px;
				word-break: break-all;
			}
			border-bottom: 1px solid #e6e6e6;
		}
		.nav-icon {
			display: block;
			margin-top: 19px;
			margin-right: 16px;
			width: 32px;
			height: 32px;
			background: url('../images/svg/nav-icon.svg') no-repeat;
		}
	}

	.menu-bg {
		display: none;
		left: 0;
		top: 0;
		position: fixed;
		z-index: $zindex - 1;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
	}
	.menu-bg.active {
		display: block;
	}
}
</style>
